export default {
  zh: {
    tooltip: {
      field: '可选的字段不包括由系统自动生成值的字段。比如：created by字段。',
      massUpdate: '只能修改显示在视图列表的字段',
      show: '显示',
      hide: '隐藏',
    },
    existingView: '已有视图',
    viewName: '视图名称',
    sharedBy: '分享自',
    searchPlaceHolder: '姓名/电话/邮箱',
  },
  en: {
    tooltip: {
      field: 'Fields that are generated by systems are not available for updating. i.e. "Created By" field',
      massUpdate: 'Only available to update shown columns in the View Lists.',
      show: 'Show',
      hide: 'Hide',
    },
    existingView: 'Existing Views',
    viewName: 'View Name',
    sharedBy: 'Shared By',
    searchPlaceHolder: 'Name/Phone/Email',
  },
};



// WEBPACK FOOTER //
// ./src/views/ObjectList/i18n.js